import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import ProductModal from "./ProductModal";

const ProductSection = () => {
  const [products, setProducts] = useState([]);
  //const [openModal, setOpenModal] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);

  const fetchProducts = async () => {
    const res = await api.get("companyblog/admin/products/");
    setProducts(res.data);
  };

  const deleteProduct = async (id) => {
    if (!window.confirm("Delete this product?")) return;
    await api.delete(`companyblog/admin/products/${id}/delete/`);
    fetchProducts();
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <>
    <div className="card">
      <div className="card-header d-flex justify-content-between">
        <h5>Products</h5>
        <button className="btn btn-primary" onClick={() => setShowProductModal(true)}>
          New Product
        </button>
      </div>

      <div className="card-body">
        <table className="table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Product</th>
              <th>Category</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {products.map((p) => (
              <tr key={p.product_id}>
                <td>
                  <img src={p.product_image} width="70" alt="" />
                </td>
                <td>{p.product_name}</td>
                <td>{p.category_name}</td>
                <td>
                  {p.status ? (
                    <span className="badge bg-success">Active</span>
                  ) : (
                    <span className="badge bg-danger">Inactive</span>
                  )}
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => deleteProduct(p.product_id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    <ProductModal
          show={showProductModal}
          onClose={() => setShowProductModal(false)}
          onCreated={fetchProducts}
    />
    </>
  );
};

export default ProductSection;
